module.exports = __webpack_public_path__ + "img/logo.fa65fb27.png";